"use client";

const ProblemXy = () => {
  return (
    <section className="flex w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] py-[90px] bg-white mx-auto">
      {/* 主体部分 */}
      <div className="flex flex-col w-full max-w-[1360px] mx-auto gap-[80px] justify-center items-center">
        {/* 上面部分 - 标题区域 */}
        <div className="flex flex-col w-full min-h-[52px] mx-auto items-center justify-center">
          {/* 标题文字 */}
          <h2 className="h-auto font-semibold text-[46px] leading-[52px] tracking-[0px] text-[#333333] text-center">
            常见问题
          </h2>
        </div>
        {/* 下面部分 */}
        <div className="flex flex-row [@media(max-width:1080px)]:flex-col w-full min-h-[134px] mx-auto justify-center gap-[24px] items-stretch">
          <div className="flex w-full gap-[10px] rounded-[20px] p-[24px] bg-[#F8FAFD]">
            <div className="flex  w-full gap-[12px]">
              <div className=" font-semibold text-lg leading-7 tracking-[2px] text-[#1DBA55]">
                01
              </div>
              <div className="gap-[2px]">
                <div className="font-semibold text-[18px] leading-[28px] tracking-[2px] text-black">
                  Q：批改学科？批改学段？批改题型？
                </div>
                <div className="font-normal text-base leading-7 tracking-normal text-[#666666]">
                  A：全学科 全学段 有唯一标准答案题型都可批改。
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full gap-[10px] rounded-[20px] p-[24px] bg-[#F8FAFD]">
            <div className="flex  w-full gap-[12px]">
              <div className=" font-semibold text-lg leading-7 tracking-[2px] text-[#1DBA55]">
                02
              </div>
              <div className="gap-[2px]">
                <div className="font-semibold text-[18px] leading-[28px] tracking-[2px] text-black">
                  Q：是否能批改作文？
                </div>
                <div className="font-normal text-base leading-7 tracking-normal text-[#666666]">
                  A：支持语文和英语作文批改。
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full gap-[10px] rounded-[20px] p-[24px] bg-[#F8FAFD]">
            <div className="flex  w-full gap-[12px]">
              <div className=" font-semibold text-lg leading-7 tracking-[2px] text-[#1DBA55]">
                03
              </div>
              <div className="gap-[2px]">
                <div className="font-semibold text-[18px] leading-[28px] tracking-[2px] text-black">
                  Q：是否有错题本？
                </div>
                <div className="font-normal text-base leading-7 tracking-normal text-[#666666]">
                  A：系统自动收录学生和班级错题，并支持错题重练。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemXy;
